import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { GeneralService } from '@shared/services/general.service';
import { SnackbarService } from '@shared/services/snackbar.service';
import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private snackbarService = inject(SnackbarService);
  private zone = inject(NgZone);
  private generalService = inject(GeneralService);

  handleError(error: Error): void {
    this.zone.run(() => {
      // client-side error
      if (!this.generalService.handeledByHTTPIntercepter) {
        console.log('Client-side error', error);
        this.snackbarService.showError('global_errorhandling_client');
        Sentry.captureException(error);
        console.error(error);
      }
      this.generalService.handeledByHTTPIntercepter = false;
    });
  }
}
